import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CMSApiService, CraeteTshirtDTO } from 'features/cms/api/cms-api.service';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

import { eventsQueryKeys } from './query-keys';

const { createTshirtSize } = CMSApiService();

export const useCreateTshirtSize = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: CraeteTshirtDTO) => {
            return createTshirtSize(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success(i18n.t('fields.create.successfulCreate'));
            },
        },
    );
};
